import React, { Component } from 'react';
import FullCalendar, { formatDate } from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";
import './calendar.css'
import { httpClient } from "../../utils/HttpClient";
import { server } from "../../constants";
// import { INITIAL_EVENTS, createEventId } from './event-utils'


function renderEventContent(eventInfo) {
  return (
    <>
      {/* <b>{eventInfo.timeText}</b> */}
      <a href={"/calendar-detail?p=" + eventInfo.event.title} target="_blank">
        <i>{eventInfo.event.title}</i>
      </a>
    </>
  )
}

// function renderSidebarEvent(event) {
//   return (
//     <li key={event.id}>
//       <b>{formatDate(event.start, {year: 'numeric', month: 'short', day: 'numeric'})}</b>
//       <i>{event.title}</i>
//     </li>
//   )
// }

class Calendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      weekendsVisible: true,
      currentEvents: [],
      _fullCalendar: null,
      datas: null
    }
  }

  async componentDidMount() {
    let result = await httpClient.get(server.CALENDAR_URL)
    this.setState({datas: result.data, _fullCalendar: await this.renderCalendar(result.data)})
    // console.log(this.state.datas)
  }

  renderCalendar(EVENTS){    
    return (
            <FullCalendar
              locale="TH"
              timeZone="TH"
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
              headerToolbar={{
                left: 'prev,next',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listDay'
              }}
              today={true}
              initialView='dayGridMonth'
              editable={true}
              selectable={true}
              selectMirror={true}
              // dayMaxEvents={true}
              weekends={this.state.weekendsVisible}
              initialEvents={EVENTS} // alternatively, use the `events` setting to fetch from a feed
              eventContent={renderEventContent} // custom render function
              // eventClick={this.handleEventClick}
              eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
            />
    )
  }


  
  handleWeekendsToggle = () => {
    this.setState({
      weekendsVisible: !this.state.weekendsVisible
    })
  }
  
  
  handleEventClick = (clickInfo) => {
    // alert(clickInfo.event.title)
    this.props.history.push('/calendar-detail?p=' + clickInfo.event.title)
    // console.log(clickInfo.event.id)
  }
  
  handleEvents = (events) => {
    this.setState({
      currentEvents: events
    })
  }


  render() {
    const styles = {
      width: '100%',
    }
    return (
      <div>
        {/* Titlebar */}
        <div className="parallax titlebar" data-background="images/popular-location-01.jpg" data-color="rgba(48, 48, 48, 1)" data-color-opacity="0.8" data-img-width={800} data-img-height={505}>
            <div id="titlebar">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h2>ปฏิทินกิจกรรม</h2>
                    {/* Breadcrumbs */}
                    <nav id="breadcrumbs">
                      <ul>
                        <li><a href="index">หน้าแรก</a></li>
                        <li>ปฏิทินกิจกรรม</li> 
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-6" style={{border: '1px solid lightgray', borderRadius: '5px', height: 693}}>
                <div className="margin-top-10"></div>
                {this.state._fullCalendar}
                <div className="margin-top-10"></div>
              </div>


              <div className="col-md-6" style={{border: '1px solid lightgray', borderRadius: '5px', borderLeft: '0px',height: 693, overflow: "auto"}}>
                <div className="row">
                  <div className="col-md-9 col-sm-12">
                    <div className="title-box matchHeight" style={{height: 497}}>
                      <div className="event">
                        <a href="https://www.reic.or.th/Activities/CalendarDetail/74" title="สถานการณ์ตลาดที่อยู่อาศัย ครึ่งหลังปี 2564 และแนวโน้มปี 2565 ภายใต้วิกฤติโควิด-19 (กรุงเทพฯ – ปริมณฑล และภาคกลาง)" target="_blank">
                          <img src="https://www.reic.or.th/Upload/AdOnlineSeminar2021H2388X409BKK_973_1629045361_28906.jpg" className="width" alt="banner" style={styles} /></a>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-3 col-sm-12">
                    <div className="title-box date matchHeight" style={{height: 497}}>
                      <div className="row">
                        <div className="col-12">
                          <div className="event">
                            <a href="https://www.reic.or.th/Activities/CalendarDetail/75" title="สถานการณ์ตลาดที่อยู่อาศัย ครึ่งหลังปี 2564 และแนวโน้มปี 2565 ภายใต้วิกฤติโควิด-19 (ภาคเหนือ)" target="_blank"><img src="https://www.reic.or.th/Upload/AdOnlineSeminar2021H2388X409North_641_1629078806_03261.jpg" className="width" alt="banner" style={styles}/></a>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="event">
                            <a href="https://www.reic.or.th/Activities/CalendarDetail/76" title="สถานการณ์ตลาดที่อยู่อาศัย ครึ่งหลังปี 2564 และแนวโน้มปี 2565 ภายใต้วิกฤติโควิด-19 (ภาคตะวันออกพื้นที่ EEC)" target="_blank"><img src="https://www.reic.or.th/Upload/AdOnlineSeminar2021H2388X409EEC_42_1629078864_84513.jpg" className="width" alt="banner" style={styles}/></a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              
              </div>
            </div>
          </div>

          <div className="margin-bottom-50"></div>

      </div>
    );
  }
}

export default Calendar;
